export const droneCategories = {
    "acsl-pf1": { displayName: "ACSL PF1" },
    "aee-mach": { displayName: "AEE Mach" },
    "anzu-raptor": { displayName: "Anzu Raptor" },
    "arace-griffin": { displayName: "Arace Griffin" },
    "ascent-helius": { displayName: "Ascent Helius" },
    "ascent-spartan": { displayName: "Ascent Spartan" },
    "ascent-spirit": { displayName: "Ascent Spirit" },
    "autel-alpha": { displayName: "Autel Alpha" },
    "autel-evo": { displayName: "Autel EVO" },
    "autel-evo-max": { displayName: "Autel EVO Max" },
    "autel-lite": { displayName: "Autel Lite" },
    "autel-nano": { displayName: "Autel Nano" },
    "autel-dragonfish": { displayName: "Autel Dragonfish" },
    "azur-skeyetech": { displayName: "Azur Skeyetech" },
    "brinc-lemur": { displayName: "Brinc Lemur" },
    "brinc-responder": { displayName: "Brinc Responder" },
    callisto: { displayName: "Callisto" },
    "dji-agras": { displayName: "DJI Agras" },
    "dji-air": { displayName: "DJI Air" },
    "dji-avata": { displayName: "DJI Avata" },
    "dji-flip": { displayName: "DJI Flip" },
    "dji-flycart": { displayName: "DJI FlyCart" },
    "dji-fpv": { displayName: "DJI FPV" },
    "dji-inspire": { displayName: "DJI Inspire" },
    "dji-lito": { displayName: "DJI Lito" },
    "dji-matrice": { displayName: "DJI Matrice" },
    "dji-mavic": { displayName: "DJI Mavic" },
    "dji-mini": { displayName: "DJI Mini" },
    "dji-neo": { displayName: "DJI Neo" },
    "dji-phantom": { displayName: "DJI Phantom" },
    "dji-spark": { displayName: "DJI Spark" },
    "event-38-e": { displayName: "Event 38 E Series" },
    "flightwave-edge": { displayName: "FlightWave Edge" },
    "flyability-elios": { displayName: "Flyability Elios" },
    "flybotix-asio": { displayName: "Flybotix Asio" },
    "freefly-alta": { displayName: "Freefly Alta" },
    "freefly-astro": { displayName: "Freefly Astro" },
    "harris-h6": { displayName: "Harris Aerial H6" },
    "hylio-ag": { displayName: "Hylio AG" },
    "inspired-flight-if1200": { displayName: "Inspired Flight IF1200" },
    "microdrones-md4": { displayName: "Microdrones md4" },
    "parrot-anafi": { displayName: "Parrot Anafi" },
    "parrot-bebop": { displayName: "Parrot Bebop" },
    "parrot-disco": { displayName: "Parrot Disco" },
    "parrot-mambo": { displayName: "Parrot Mambo" },
    "prism-lite": { displayName: "Prism Lite" },
    "quantum-trinity": { displayName: "Quantum Trinity" },
    "sensefly-ebee": { displayName: "senseFly eBee" },
    "sentera-phx": { displayName: "Sentera PHX" },
    "skydio-r1": { displayName: "Skydio R1" },
    "skydio-2": { displayName: "Skydio 2" },
    "skydio-x": { displayName: "Skydio X" },
    "sony-airpeak": { displayName: "Sony Airpeak" },
    "teal-2": { displayName: "Teal 2" },
    "teal-black-widow": { displayName: "Teal Black Widow" },
    "teal-golden-eagle": { displayName: "Teal Golden Eagle" },
    "teledyne-siras": { displayName: "Teledyne FLIR Siras" },
    "vantage-trace": { displayName: "Vantage Trace" },
    "vantage-vesper": { displayName: "Vantage Vesper" },
    "voliro-t": { displayName: "Voliro T" },
    "wingcopter-198": { displayName: "Wingcopter 198" },
    "wingtra-ray": { displayName: "WingtraRay" },
    "wispr-ranger": { displayName: "Wispr Ranger" },
    "yuneec-h520": { displayName: "Yuneec H520" },
} as const satisfies Record<string, { displayName: string }>

export type DroneCategory = keyof typeof droneCategories

export const droneCatalog = {
    acsl: {
        displayName: "ACSL",
        aliases: [],
        models: {
            pf1: { displayName: "PF1", aliases: [], category: "acsl-pf1" },
        },
    },
    aee: {
        displayName: "AEE",
        aliases: [],
        models: {
            "mach-4": { displayName: "Mach 4", aliases: [], category: "aee-mach" },
            "mach-6": { displayName: "Mach 6", aliases: [], category: "aee-mach" },
        },
    },
    "anzu-robotics": {
        displayName: "Anzu Robotics",
        aliases: [],
        models: {
            raptor: { displayName: "Raptor", aliases: [], category: "anzu-raptor" },
        },
    },
    arace: {
        displayName: "Arace",
        aliases: [],
        models: {
            "griffin-pro": { displayName: "Griffin Pro", aliases: [], category: "arace-griffin" },
        },
    },
    "ascent-aerosystems": {
        displayName: "Ascent AeroSystems",
        aliases: [],
        models: {
            helius: { displayName: "Helius", aliases: [], category: "ascent-helius" },
            spartan: { displayName: "Spartan", aliases: [], category: "ascent-spartan" },
            spirit: { displayName: "Spirit", aliases: [], category: "ascent-spirit" },
        },
    },
    autel: {
        displayName: "Autel Robotics",
        aliases: ["Autel"],
        models: {
            alpha: { displayName: "Alpha", aliases: [], category: "autel-alpha" },
            evo: { displayName: "EVO", aliases: [], category: "autel-evo" },
            "evo-2": { displayName: "EVO II", aliases: ["EVO II", "EVO 2"], category: "autel-evo" },
            "evo-max-4n": {
                displayName: "EVO Max 4N",
                aliases: ["EVO Max 4 N"],
                category: "autel-evo-max",
            },
            "evo-max-4t": {
                displayName: "EVO Max 4T",
                aliases: ["EVO Max 4 T"],
                category: "autel-evo-max",
            },
            "evo-max-4t-xe": {
                displayName: "EVO Max 4T XE",
                aliases: ["EVO Max 4 T XE"],
                category: "autel-evo-max",
            },
            lite: { displayName: "Lite", aliases: [], category: "autel-lite" },
            "lite-plus": { displayName: "Lite+", aliases: ["Lite Plus"], category: "autel-lite" },
            nano: { displayName: "Nano", aliases: [], category: "autel-nano" },
            "nano-plus": { displayName: "Nano+", aliases: ["Nano Plus"], category: "autel-nano" },
            "dragonfish-lite": {
                displayName: "Dragonfish Lite",
                aliases: [],
                category: "autel-dragonfish",
            },
            "dragonfish-pro": {
                displayName: "Dragonfish Pro",
                aliases: [],
                category: "autel-dragonfish",
            },
            "dragonfish-standard": {
                displayName: "Dragonfish Standard",
                aliases: [],
                category: "autel-dragonfish",
            },
        },
    },
    "azur-drones": {
        displayName: "Azur Drones",
        aliases: [],
        models: {
            "skeyetech-e2": {
                displayName: "Skeyetech E2",
                aliases: [],
                category: "azur-skeyetech",
            },
        },
    },
    brinc: {
        displayName: "Brinc",
        aliases: [],
        models: {
            "lemur-2": { displayName: "Lemur 2", aliases: [], category: "brinc-lemur" },
            responder: { displayName: "Responder", aliases: [], category: "brinc-responder" },
        },
    },
    callisto: {
        displayName: "Callisto",
        aliases: [],
        models: {
            "25": { displayName: "25", aliases: [], category: "callisto" },
            "50": { displayName: "50", aliases: [], category: "callisto" },
            "75": { displayName: "75", aliases: [], category: "callisto" },
        },
    },
    dji: {
        displayName: "DJI",
        aliases: [],
        models: {
            "agras-t100": { displayName: "Agras T100", aliases: ["T100"], category: "dji-agras" },
            "agras-t25p": { displayName: "Agras T25P", aliases: ["T25P"], category: "dji-agras" },
            "agras-t70p": { displayName: "Agras T70P", aliases: ["T70P"], category: "dji-agras" },
            "agras-mg-1": { displayName: "Agras MG-1", aliases: ["MG-1"], category: "dji-agras" },
            "agras-mg-1p": {
                displayName: "Agras MG-1P",
                aliases: ["MG-1P"],
                category: "dji-agras",
            },
            "agras-t10": { displayName: "Agras T10", aliases: ["T10"], category: "dji-agras" },
            "agras-t20": { displayName: "Agras T20", aliases: ["T20"], category: "dji-agras" },
            "agras-t20p": { displayName: "Agras T20P", aliases: ["T20P"], category: "dji-agras" },
            "agras-t30": { displayName: "Agras T30", aliases: ["T30"], category: "dji-agras" },
            "agras-t40": { displayName: "Agras T40", aliases: ["T40"], category: "dji-agras" },
            "agras-t50": { displayName: "Agras T50", aliases: ["T50"], category: "dji-agras" },
            "air-2s": { displayName: "Air 2S", aliases: ["MavicAir2S"], category: "dji-air" },
            "air-3": { displayName: "Air 3", aliases: [], category: "dji-air" },
            "air-3s": { displayName: "Air 3S", aliases: [], category: "dji-air" },
            avata: { displayName: "Avata", aliases: [], category: "dji-avata" },
            "avata-2": { displayName: "Avata 2", aliases: ["Avata2"], category: "dji-avata" },
            flip: { displayName: "Flip", aliases: [], category: "dji-flip" },
            "flycart-30": { displayName: "FlyCart 30", aliases: [], category: "dji-flycart" },
            fpv: { displayName: "FPV", aliases: ["DJI FPV"], category: "dji-fpv" },
            "inspire-1": {
                displayName: "Inspire 1",
                aliases: ["Inspire1"],
                category: "dji-inspire",
            },
            "inspire-2": {
                displayName: "Inspire 2",
                aliases: ["Inspire2"],
                category: "dji-inspire",
            },
            "inspire-3": { displayName: "Inspire 3", aliases: [], category: "dji-inspire" },
            lito: { displayName: "Lito", aliases: [], category: "dji-lito" },
            "lito-x1": { displayName: "Lito X1", aliases: [], category: "dji-lito" },
            m30: { displayName: "M30", aliases: ["Matrice30"], category: "dji-matrice" },
            "matrice-100": {
                displayName: "Matrice 100",
                aliases: ["M100", "Matrice100"],
                category: "dji-matrice",
            },
            "matrice-200": {
                displayName: "Matrice 200",
                aliases: ["M200", "Matrice200"],
                category: "dji-matrice",
            },
            "matrice-200-v2": {
                displayName: "Matrice 200 V2",
                aliases: ["Matrice200V2"],
                category: "dji-matrice",
            },
            "matrice-210": {
                displayName: "Matrice 210",
                aliases: ["M210", "Matrice210"],
                category: "dji-matrice",
            },
            "matrice-210-v2": {
                displayName: "Matrice 210 V2",
                aliases: ["Matrice210V2"],
                category: "dji-matrice",
            },
            "matrice-210-rtk": {
                displayName: "Matrice 210 RTK",
                aliases: ["M210 RTK", "Matrice210RTK"],
                category: "dji-matrice",
            },
            "matrice-210-rtk-v2": {
                displayName: "Matrice 210 RTK V2",
                aliases: ["Matrice210RTKV2"],
                category: "dji-matrice",
            },
            "matrice-300-rtk": {
                displayName: "Matrice 300 RTK",
                aliases: ["M300 RTK", "Matrice300RTK"],
                category: "dji-matrice",
            },
            "matrice-350-rtk": {
                displayName: "Matrice 350 RTK",
                aliases: ["M350 RTK", "Matrice350RTK"],
                category: "dji-matrice",
            },
            "matrice-3d": { displayName: "Matrice 3D", aliases: ["M3D"], category: "dji-matrice" },
            "matrice-3td": {
                displayName: "Matrice 3TD",
                aliases: ["M3TD"],
                category: "dji-matrice",
            },
            "matrice-400": {
                displayName: "Matrice 400",
                aliases: ["M400", "181"],
                category: "dji-matrice",
            },
            "matrice-4d": { displayName: "Matrice 4D", aliases: ["M4D"], category: "dji-matrice" },
            "matrice-4e": { displayName: "Matrice 4E", aliases: ["M4E"], category: "dji-matrice" },
            "matrice-4t": {
                displayName: "Matrice 4T",
                aliases: ["M4T", "150"],
                category: "dji-matrice",
            },
            "matrice-4td": {
                displayName: "Matrice 4TD",
                aliases: ["M4TD"],
                category: "dji-matrice",
            },
            "matrice-600": {
                displayName: "Matrice 600",
                aliases: ["M600", "Matrice600"],
                category: "dji-matrice",
            },
            "matrice-600-pro": {
                displayName: "Matrice 600 Pro",
                aliases: ["M600 Pro", "Matrice600Pro"],
                category: "dji-matrice",
            },
            "mavic-2-enterprise": {
                displayName: "Mavic 2 Enterprise",
                aliases: ["Mavic2Enterprise"],
                category: "dji-mavic",
            },
            "mavic-2-enterprise-advanced": {
                displayName: "Mavic 2 Enterprise Advanced",
                aliases: [],
                category: "dji-mavic",
            },
            "mavic-2-pro": {
                displayName: "Mavic 2 Pro",
                aliases: ["Mavic2"],
                category: "dji-mavic",
            },
            "mavic-2-zoom": { displayName: "Mavic 2 Zoom", aliases: [], category: "dji-mavic" },
            "mavic-3": { displayName: "Mavic 3", aliases: ["Mavic3"], category: "dji-mavic" },
            "mavic-3-classic": {
                displayName: "Mavic 3 Classic",
                aliases: [],
                category: "dji-mavic",
            },
            "mavic-3-enterprise": {
                displayName: "Mavic 3 Enterprise",
                aliases: ["Mavic3Enterprise"],
                category: "dji-mavic",
            },
            "mavic-3-multispectral": {
                displayName: "Mavic 3 Multispectral",
                aliases: [],
                category: "dji-mavic",
            },
            "mavic-3-pro": {
                displayName: "Mavic 3 Pro",
                aliases: ["Mavic3Pro"],
                category: "dji-mavic",
            },
            "mavic-3-thermal": {
                displayName: "Mavic 3 Thermal",
                aliases: [],
                category: "dji-mavic",
            },
            "mavic-4-pro": { displayName: "Mavic 4 Pro", aliases: [], category: "dji-mavic" },
            "mavic-air": { displayName: "Mavic Air", aliases: ["MavicAir"], category: "dji-air" },
            "mavic-air-2": {
                displayName: "Mavic Air 2",
                aliases: ["MavicAir2"],
                category: "dji-air",
            },
            "mavic-mini": {
                displayName: "Mavic Mini",
                aliases: ["MavicMini"],
                category: "dji-mini",
            },
            "mavic-pro": {
                displayName: "Mavic Pro",
                aliases: ["MavicPro"],
                category: "dji-mavic",
            },
            "mini-2": { displayName: "Mini 2", aliases: ["Mini2"], category: "dji-mini" },
            "mini-2-se": { displayName: "Mini 2 SE", aliases: ["Mini2SE"], category: "dji-mini" },
            "mini-3": { displayName: "Mini 3", aliases: [], category: "dji-mini" },
            "mini-3-pro": {
                displayName: "Mini 3 Pro",
                aliases: ["Mini3Pro"],
                category: "dji-mini",
            },
            "mini-4-pro": {
                displayName: "Mini 4 Pro",
                aliases: ["Mini4Pro"],
                category: "dji-mini",
            },
            "mini-4k": { displayName: "Mini 4K", aliases: [], category: "dji-mini" },
            "mini-5-pro": { displayName: "Mini 5 Pro", aliases: [], category: "dji-mini" },
            "mini-se": { displayName: "Mini SE", aliases: ["MiniSE"], category: "dji-mini" },
            neo: { displayName: "Neo", aliases: ["182"], category: "dji-neo" },
            "neo-2": { displayName: "Neo 2", aliases: [], category: "dji-neo" },
            "phantom-3-4k": {
                displayName: "Phantom 3 4K",
                aliases: ["Phantom34K"],
                category: "dji-phantom",
            },
            "phantom-3-advanced": {
                displayName: "Phantom 3 Advanced",
                aliases: ["Phantom3Advanced"],
                category: "dji-phantom",
            },
            "phantom-3-pro": {
                displayName: "Phantom 3 Pro",
                aliases: ["Phantom3Pro"],
                category: "dji-phantom",
            },
            "phantom-3-se": {
                displayName: "Phantom 3 SE",
                aliases: ["Phantom3SE"],
                category: "dji-phantom",
            },
            "phantom-3-standard": {
                displayName: "Phantom 3 Standard",
                aliases: ["Phantom3Standard"],
                category: "dji-phantom",
            },
            "phantom-4": {
                displayName: "Phantom 4",
                aliases: ["Phantom4"],
                category: "dji-phantom",
            },
            "phantom-4-advanced": {
                displayName: "Phantom 4 Advanced",
                aliases: ["Phantom4Advanced"],
                category: "dji-phantom",
            },
            "phantom-4-multispectral": {
                displayName: "Phantom 4 Multispectral",
                aliases: ["Phantom4Multispectral"],
                category: "dji-phantom",
            },
            "phantom-4-pro": {
                displayName: "Phantom 4 Pro",
                aliases: ["Phantom4Pro"],
                category: "dji-phantom",
            },
            "phantom-4-pro-v2": {
                displayName: "Phantom 4 Pro V2",
                aliases: ["Phantom4ProV2"],
                category: "dji-phantom",
            },
            "phantom-4-rtk": {
                displayName: "Phantom 4 RTK",
                aliases: ["Phantom4RTK"],
                category: "dji-phantom",
            },
            spark: { displayName: "Spark", aliases: [], category: "dji-spark" },
        },
    },
    "event-38": {
        displayName: "Event 38",
        aliases: [],
        models: {
            e400: { displayName: "E400", aliases: [], category: "event-38-e" },
            e455: { displayName: "E455", aliases: [], category: "event-38-e" },
        },
    },
    flightwave: {
        displayName: "FlightWave",
        aliases: [],
        models: {
            "edge-130": { displayName: "Edge 130", aliases: [], category: "flightwave-edge" },
        },
    },
    flyability: {
        displayName: "Flyability",
        aliases: [],
        models: {
            "elios-2": { displayName: "Elios 2", aliases: [], category: "flyability-elios" },
            "elios-3": { displayName: "Elios 3", aliases: [], category: "flyability-elios" },
        },
    },
    flybotix: {
        displayName: "Flybotix",
        aliases: [],
        models: {
            "asio-pro": { displayName: "Asio Pro", aliases: [], category: "flybotix-asio" },
            "asio-x": { displayName: "Asio X", aliases: [], category: "flybotix-asio" },
        },
    },
    freefly: {
        displayName: "Freefly",
        aliases: [],
        models: {
            "alta-6": { displayName: "Alta 6", aliases: [], category: "freefly-alta" },
            "alta-8": { displayName: "Alta 8", aliases: [], category: "freefly-alta" },
            "alta-x": { displayName: "Alta X", aliases: [], category: "freefly-alta" },
            astro: { displayName: "Astro", aliases: [], category: "freefly-astro" },
        },
    },
    "harris-aerial": {
        displayName: "Harris Aerial",
        aliases: [],
        models: {
            h6: { displayName: "H6", aliases: [], category: "harris-h6" },
        },
    },
    hylio: {
        displayName: "Hylio",
        aliases: [],
        models: {
            "ag-210": { displayName: "AG-210", aliases: [], category: "hylio-ag" },
            "ag-216": { displayName: "AG-216", aliases: [], category: "hylio-ag" },
            "ag-230": { displayName: "AG-230", aliases: [], category: "hylio-ag" },
            "ag-272": { displayName: "AG-272", aliases: [], category: "hylio-ag" },
        },
    },
    "inspired-flight": {
        displayName: "Inspired Flight",
        aliases: [],
        models: {
            if1200: { displayName: "IF1200", aliases: [], category: "inspired-flight-if1200" },
        },
    },
    microdrones: {
        displayName: "Microdrones",
        aliases: [],
        models: {
            "md4-200": { displayName: "md4-200", aliases: [], category: "microdrones-md4" },
            "md4-1000": { displayName: "md4-1000", aliases: [], category: "microdrones-md4" },
            "md4-3000": { displayName: "md4-3000", aliases: [], category: "microdrones-md4" },
        },
    },
    parrot: {
        displayName: "Parrot",
        aliases: [],
        models: {
            anafi: { displayName: "Anafi", aliases: [], category: "parrot-anafi" },
            "anafi-ai": { displayName: "Anafi AI", aliases: [], category: "parrot-anafi" },
            "anafi-thermal": {
                displayName: "Anafi Thermal",
                aliases: [],
                category: "parrot-anafi",
            },
            "anafi-usa": { displayName: "Anafi USA", aliases: [], category: "parrot-anafi" },
            bebop: { displayName: "Bebop", aliases: [], category: "parrot-bebop" },
            "bebop-2": { displayName: "Bebop 2", aliases: [], category: "parrot-bebop" },
            disco: { displayName: "Disco", aliases: [], category: "parrot-disco" },
            mambo: { displayName: "Mambo", aliases: [], category: "parrot-mambo" },
        },
    },
    prism: {
        displayName: "Prism",
        aliases: [],
        models: {
            lite: { displayName: "Lite", aliases: [], category: "prism-lite" },
        },
    },
    "quantum-systems": {
        displayName: "Quantum Systems",
        aliases: [],
        models: {
            "trinity-f90-plus": {
                displayName: "Trinity F90+",
                aliases: ["Trinity F90 Plus"],
                category: "quantum-trinity",
            },
            "trinity-pro": { displayName: "Trinity Pro", aliases: [], category: "quantum-trinity" },
        },
    },
    sensefly: {
        displayName: "senseFly",
        aliases: ["SenseFly"],
        models: {
            "ebee-x": { displayName: "eBee X", aliases: [], category: "sensefly-ebee" },
        },
    },
    sentera: {
        displayName: "Sentera",
        aliases: [],
        models: {
            phx: { displayName: "PHX", aliases: [], category: "sentera-phx" },
        },
    },
    skydio: {
        displayName: "Skydio",
        aliases: [],
        models: {
            r1: { displayName: "R1", aliases: ["Skydio R1"], category: "skydio-r1" },
            "2": { displayName: "2", aliases: ["Skydio 2"], category: "skydio-2" },
            x2: { displayName: "X2", aliases: ["Skydio X2"], category: "skydio-x" },
            x10: { displayName: "X10", aliases: ["Skydio X10"], category: "skydio-x" },
        },
    },
    sony: {
        displayName: "Sony",
        aliases: [],
        models: {
            "airpeak-s1": {
                displayName: "Airpeak S1",
                aliases: ["Airpeak S1"],
                category: "sony-airpeak",
            },
        },
    },
    teal: {
        displayName: "Teal Drones",
        aliases: ["Teal"],
        models: {
            "2": { displayName: "2", aliases: [], category: "teal-2" },
            "black-widow": {
                displayName: "Black Widow",
                aliases: [],
                category: "teal-black-widow",
            },
            "golden-eagle": {
                displayName: "Golden Eagle",
                aliases: [],
                category: "teal-golden-eagle",
            },
        },
    },
    teledyne: {
        displayName: "Teledyne",
        aliases: [],
        models: {
            "flir-siras": {
                displayName: "FLIR Siras",
                aliases: ["FLIR SIRAS"],
                category: "teledyne-siras",
            },
        },
    },
    "vantage-robotics": {
        displayName: "Vantage Robotics",
        aliases: [],
        models: {
            trace: { displayName: "Trace", aliases: [], category: "vantage-trace" },
            vesper: { displayName: "Vesper", aliases: [], category: "vantage-vesper" },
        },
    },
    voliro: {
        displayName: "Voliro",
        aliases: [],
        models: {
            t: { displayName: "T", aliases: [], category: "voliro-t" },
        },
    },
    wingcopter: {
        displayName: "Wingcopter",
        aliases: [],
        models: {
            "198": { displayName: "198", aliases: [], category: "wingcopter-198" },
        },
    },
    wingtra: {
        displayName: "Wingtra",
        aliases: [],
        models: {
            wingtraray: { displayName: "WingtraRay", aliases: [], category: "wingtra-ray" },
        },
    },
    wispr: {
        displayName: "Wispr Systems",
        aliases: ["Wispr"],
        models: {
            "ranger-pro": { displayName: "Ranger Pro", aliases: [], category: "wispr-ranger" },
        },
    },
    yuneec: {
        displayName: "Yuneec",
        aliases: [],
        models: {
            h520: { displayName: "H520", aliases: [], category: "yuneec-h520" },
        },
    },
} as const satisfies Record<
    string,
    {
        displayName: string
        aliases: readonly string[]
        models: Record<
            string,
            { displayName: string; aliases: readonly string[]; category: DroneCategory }
        >
    }
>

export type DroneMake = keyof typeof droneCatalog
export type DroneModel<M extends DroneMake> = {
    [K in keyof (typeof droneCatalog)[M]["models"]]: (typeof droneCatalog)[M]["models"][K] extends {
        aliases: readonly (infer A)[]
    }
        ? K | A
        : K
}[keyof (typeof droneCatalog)[M]["models"]]

type AnyModelMap = Record<
    string,
    { displayName: string; aliases: readonly string[]; category: DroneCategory }
>

export function getDroneMakeDisplayName(make: DroneMake) {
    return droneCatalog[make].displayName
}

export function getDroneModelDisplayName<M extends DroneMake>(make: M, model: DroneModel<M>) {
    return (droneCatalog[make].models as AnyModelMap)[model as string].displayName
}

export function getDroneCategoryDisplayName(category: DroneCategory) {
    return droneCategories[category].displayName
}

export function getDroneCategory<M extends DroneMake>(
    make: M,
    model: DroneModel<M>
): DroneCategory {
    return (droneCatalog[make].models as AnyModelMap)[model as string].category
}

export function normalizeDroneMake(value: string) {
    const lower = value.trim().toLowerCase()
    for (const key of Object.keys(droneCatalog) as DroneMake[]) {
        if (key === lower) return key
        const entry = droneCatalog[key]
        if (entry.displayName.toLowerCase() === lower) return key
        if ((entry.aliases as readonly string[]).some((a) => a.toLowerCase() === lower)) return key
    }
    return undefined
}

export function normalizeDroneModel<M extends DroneMake>(
    make: M,
    value: string
): DroneModel<M> | undefined {
    const lower = value.trim().toLowerCase()
    const models = droneCatalog[make].models as AnyModelMap
    for (const key of Object.keys(models)) {
        if (key === lower) return key as DroneModel<M>
        const entry = models[key]
        if (entry.displayName.toLowerCase() === lower) return key as DroneModel<M>
        if (entry.aliases.some((a) => a.toLowerCase() === lower)) return key as DroneModel<M>
    }
    return undefined
}

export function resolveDroneCategory(
    manufacturer: string | null | undefined,
    model: string | null | undefined
): DroneCategory | undefined {
    const makeKey = normalizeDroneMake(manufacturer ?? "")
    if (!makeKey) return undefined
    const modelKey = model ? normalizeDroneModel(makeKey, model) : undefined
    if (!modelKey) return undefined
    return getDroneCategory(makeKey, modelKey)
}

export function resolveDroneModelKey(
    manufacturer: string | null | undefined,
    model: string | null | undefined
): string | undefined {
    const rawModel = model?.trim()
    if (!rawModel) return undefined
    const makeKey = normalizeDroneMake(manufacturer ?? "")
    const modelKey = makeKey ? normalizeDroneModel(makeKey, rawModel) : undefined
    const make = makeKey ?? (manufacturer?.trim().toLowerCase() || "unknown")
    return `${make}:${modelKey ?? rawModel.toLowerCase()}`
}

export function getDroneModelKeyLabel(key: string): string {
    const [make, model] = key.split(":")
    const makeKey = normalizeDroneMake(make)
    const modelKey = makeKey ? normalizeDroneModel(makeKey, model) : undefined
    if (makeKey && modelKey) {
        return `${getDroneMakeDisplayName(makeKey)} ${getDroneModelDisplayName(makeKey, modelKey)}`
    }
    return model
}

export function getDisplayableAircraftData<
    T extends { nickname?: string | null; manufacturer?: string | null; model?: string | null },
>({ nickname, manufacturer, model }: T) {
    const makeKey = normalizeDroneMake(manufacturer ?? "")
    const modelKey = makeKey && model ? normalizeDroneModel(makeKey, model) : undefined
    const cleanModel = modelKey ? getDroneModelDisplayName(makeKey!, modelKey) : model
    const displayName =
        nickname ??
        cleanModel ??
        (makeKey ? getDroneMakeDisplayName(makeKey) : manufacturer) ??
        "Unknown"
    return {
        displayName,
        make: makeKey ? droneCatalog[makeKey].displayName : manufacturer,
        model: cleanModel,
    }
}
